import { render, staticRenderFns } from "./MakeRequestJoinFormPopup.vue?vue&type=template&id=4019676b&scoped=true&"
import script from "./MakeRequestJoinFormPopup.vue?vue&type=script&lang=js&"
export * from "./MakeRequestJoinFormPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4019676b",
  null
  
)

export default component.exports